export const SHIPPING_PACKAGE_PRESETS = {
  smallPaperback: { weightKg: '0.3', lengthCm: '23', widthCm: '15', heightCm: '3' },
  standardPaperback: { weightKg: '0.5', lengthCm: '23', widthCm: '15', heightCm: '4' },
  standardHardcover: { weightKg: '0.9', lengthCm: '25', widthCm: '17', heightCm: '6' },
  largeHardcover: { weightKg: '1.4', lengthCm: '32', widthCm: '24', heightCm: '8' },
  twoBookSet: { weightKg: '1.2', lengthCm: '25', widthCm: '18', heightCm: '8' },
  boxSet: { weightKg: '2.5', lengthCm: '32', widthCm: '25', heightCm: '15' },
};

export const isShippingPackagePreset = shippingDetails => {
  const preset = SHIPPING_PACKAGE_PRESETS[shippingDetails?.packageType];
  return (
    !!preset &&
    Object.keys(preset).every(key => Number(shippingDetails?.[key]) === Number(preset[key]))
  );
};

export const normalizeCanadianPostalCode = value => {
  const normalized = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return normalized.length === 6 ? `${normalized.slice(0, 3)} ${normalized.slice(3)}` : value || '';
};

export const isValidCanadianPostalCode = value =>
  /^[A-Z]\d[A-Z] ?\d[A-Z]\d$/.test(normalizeCanadianPostalCode(value));

export const isShippableListingType = listingType =>
  ['book-listing', 'collector-merch'].includes(listingType);
